import Input from "../inputs/Input";
import { AiOutlineLoading } from "react-icons/ai";
import useCEP from "../../hooks/useCEP";
import { useForm } from "react-hook-form";
import { AVATAR, USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useEffect, useState } from "react";
import CPFInput from "../inputs/CPFInput";
import PhoneInput from "../inputs/PhoneInput";
import { resetValuesForm } from "../../utils/utils";
import SelectInput from "../inputs/SelectInput";
import ImageInput from "../inputs/ImageInput";
import { useApplication } from "../../contexts/ApplicationContext";

const UserForm = ({
  user,
  fetchUsers,
  onClose,
  isOpen,
  type = "CREATE",
  companyId = null,
}) => {
  const { userPermission } = useApplication();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [key, setKey] = useState(0);
  const [error, setError] = useState(null);
  const [avatarImg, setAvatarImg] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (type === "EDIT" && user) {
      reset({ ...user, password: "" });
      setPreviewUrl(user?.imageUrl);
      setAvatarImg(user?.avatar);
      setKey((prev) => prev + 1);
    } else if (type === "CREATE") {
      reset({});
      setPreviewUrl("");
      setAvatarImg("");
    }
    setError(null);
  }, [user, isOpen]);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);

      // if (previewUrl.includes("data:image/")) {
      //   const formData = new FormData();
      //   formData.append("image", avatarImg);
      //   const { data: avatar } = await axios.post(
      //     `${AVATAR.UPLOAD}?avatar=${user?.avatar || ""}`,
      //     formData,
      //     {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     }
      //   );
      //   data.avatar = avatar.imageName;
      // }

      // if (user?.email !== data.email) {
      //   const responseEmail = await axios.get(
      //     `${USERS.GET_USER}/email/${data.email}`
      //   );

      //   if (responseEmail.status === "error") {
      //     throw new Error("E-mail já cadastrado");
      //   }
      // }

      if (type === "CREATE") {
        data.companyId = companyId;
        await axios.post(USERS.GET_USER, data);
      } else {
        if (data.password === "") delete data.password;

        await axios.put(`${USERS.GET_USER}/${user.id}`, data);
      }

      onClose(false);

      fetchUsers();

      if (type === "CREATE")
        resetValuesForm(["cpf", "phoneNumber"], setValue, reset);
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const {
    cep,
    setCep,
    address,
    loading: loadingCEP,
    error: errorCEP,
  } = useCEP();

  const onClickSearchCEP = (e) => {
    setCep(getValues("addressPostalCode"));
  };

  useEffect(() => {
    setValue("address", address?.logradouro);
    setValue("addressNeighborhood", address?.bairro);
    setValue("addressCity", address?.localidade);
  }, [address]);

  return (
    <form className="mb-6" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-6">
        <ImageInput
          image={avatarImg}
          setImage={setAvatarImg}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
        />
      </div>
      <div className="mb-6">
        <Input
          type="text"
          label="Nome *"
          name="name"
          required={true}
          register={register}
          error={errors?.name && "Este campo é obrigatório"}
        />
      </div>

      <div className="mb-6">
        <PhoneInput
          type="text"
          label="Telefone *"
          name="phoneNumber"
          required={true}
          register={register}
          error={errors?.phoneNumber && "Este campo é obrigatório"}
          control={control}
        />
      </div>

      {/* <div className="mb-6">
        <CPFInput
          type="text"
          label="Cpf"
          name="cpf"
          required={false}
          register={register}
          value={watch("cpf") || ""}
          control={control}
        />
      </div> */}

      {/* <div className="mb-6 flex gap-2">
        <Input
          type="text"
          label="CEP"
          name="addressPostalCode"
          required={false}
          register={register}
          className="w-full"
        />
        <button
          type="button"
          onClick={onClickSearchCEP}
          disabled={loadingCEP}
          className="flex items-center justify-center gap-1.5 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition disabled:opacity-50 whitespace-nowrap"
        >
          {loadingCEP && <AiOutlineLoading className="h-4 w-4 animate-spin" />}
          Buscar CEP
        </button>
      </div> */}
      {/* <div className="mb-6">
        <Input
          type="text"
          label="Endereço"
          name="address"
          required={false}
          register={register}
        />
      </div>
      <div className="mb-6">
        <div className="flex gap-4">
          <Input
            type="text"
            label="Número"
            name="addressNumber"
            required={false}
            register={register}
            className="w-full"
          />
          <Input
            type="text"
            label="Bairro"
            name="addressNeighborhood"
            required={false}
            register={register}
            className="w-full"
          />
        </div>
      </div>
      <div className="mb-6">
        <div className="flex gap-4">
          <Input
            type="text"
            label="Cidade"
            name="addressCity"
            required={false}
            register={register}
            className="w-full"
          />
        </div>
      </div>
      <div className="mb-6">
        <div className="flex flex-col md:flex-row gap-4">
          <Input
            type="date"
            label="Data de nascimento"
            name="birthday"
            required={false}
            register={register}
            className="w-full"
          />
          <div className="w-full relative">
            <select
              id="gender"
              name="gender"
              className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer"
              {...register("gender")}
            >
              <option value="">Selecione o gênero</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
            <label
              htmlFor="gender"
              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 start-1 pointer-events-none"
            >
              Sexo
            </label>
          </div>
        </div>
      </div> */}

      <div className="mb-6">
        <Input
          type="email"
          label="E-mail *"
          name="email"
          required={true}
          register={register}
          error={errors?.email && "Este campo é obrigatório"}
        />
        {errors.email && <span>{errors.email.message}</span>}
      </div>
      {["ADMIN", "POWER_USER"].includes(userPermission) && (
        <div className="mb-6">
          <Input
            type="password"
            label={`Senha ${type === "CREATE" ? "*" : ""}`}
            name="password"
            required={type === "CREATE"}
            register={register}
          />
        </div>
      )}

      {["ADMIN", "POWER_USER"].includes(userPermission) && (
        <div className="mb-6">
          <SelectInput
            register={register}
            name="permissionId"
            label="Permissão de usuário"
          >
            {userPermission === "POWER_USER" && (
              <option value="POWER_USER">Power User</option>
            )}
            <option value="ADMIN">Administrador</option>
            <option value="USER">Usuário</option>
          </SelectInput>
        </div>
      )}

      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full flex items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-gray-700 transition disabled:opacity-50 mb-4"
      >
        {isSubmitting && <AiOutlineLoading className="h-4 w-4 animate-spin" />}
        {type === "CREATE" ? "Criar" : "Atualizar"} usuário
      </button>

      {error && (
        <div className="mt-2 rounded-lg bg-red-50 border border-red-100 px-4 py-3 text-sm text-red-600">
          {error?.config?.method === "put"
            ? "Erro ao atualizar usuário"
            : error?.config?.method === "post"
            ? "Erro ao criar usuário"
            : "E-mail já cadastrado"}
        </div>
      )}
    </form>
  );
};

export default UserForm;
